"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsPageProduct = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _DmsAltBox = require("../../components/DmsAltBox/DmsAltBox");
var _DmsButtonGroup = require("../../components/DmsButtonGroup/DmsButtonGroup");
var _DmsExport = require("../../components/DmsExport/DmsExport");
var _DmsPage = require("../../components/DmsPage/DmsPage");
var _DmsPermissions = require("../../components/DmsPermissions/DmsPermissions");
var _DmsTable = require("../../components/DmsTable/DmsTable");
var _DmsTableCreateButton = require("../../components/DmsTableButton/DmsTableCreateButton");
var _DmsTableDeleteButton = require("../../components/DmsTableButton/DmsTableDeleteButton");
var _DmsTableEditButton = require("../../components/DmsTableButton/DmsTableEditButton");
var _DmsFlexContainer = require("../../components/DmsFlexContainer/DmsFlexContainer");
var _material = require("@mui/material");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * DmsPageProduct Component
 * @component
 * @description Represents the page for managing products within a Document Management System (DMS).
 * @returns {JSX.Element} The JSX element rendering the products management page.
 */
const DmsPageProduct = () => {
  const table = (0, _react.useRef)(null);

  /**
   * Table header configuration for the products table.
   * @type {Array<Object>}
   */
  const header = [{
    label: _reactIntlUniversal.default.get("Number").d("Number"),
    column_name: "number",
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("Name").d("Name"),
    column_name: "name",
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("Description").d("Description"),
    column_name: "description",
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("Actions").d("Actions"),
    permissions: ['CAN_EDIT_PRODUCT'],
    width: "80px",
    sortable: false,
    element: row => {
      const number = row.number;
      return /*#__PURE__*/_react.default.createElement(_DmsButtonGroup.DmsButtonGroup, null, /*#__PURE__*/_react.default.createElement(_DmsTableEditButton.DmsTableEditButton, {
        row: row,
        table: table,
        title: _reactIntlUniversal.default.get("Updateproduct", {
          number
        }).d("Update {number}"),
        url: '/product'
      }), /*#__PURE__*/_react.default.createElement(_DmsTableDeleteButton.DmsTableDeleteButton, {
        table: table,
        text: _reactIntlUniversal.default.get("DmsPageProduct.DeleteButtonMessage", {
          number
        }).d("The product {number} will be deleted. Are you sure about it?"),
        title: _reactIntlUniversal.default.get("Deleteproduct", {
          number
        }).d("Delete {number}"),
        url: '/product'
      }));
    }
  }];

  /**
   * Toolbar component for the products management page.
   * @type {JSX.Element}
   */
  const toolbar = /*#__PURE__*/_react.default.createElement(_DmsFlexContainer.DmsFlexContainer, null, /*#__PURE__*/_react.default.createElement(_DmsFlexContainer.DmsFlexContainer.Left, null, /*#__PURE__*/_react.default.createElement(_DmsPermissions.DmsPermissions, {
    permissions: ['CAN_EDIT_PRODUCT']
  }, /*#__PURE__*/_react.default.createElement(_DmsTableCreateButton.DmsTableCreateButton, {
    header: header,
    table: table,
    title: _reactIntlUniversal.default.get("Createproduct").d("Create product"),
    url: '/product'
  }))), /*#__PURE__*/_react.default.createElement(_DmsFlexContainer.DmsFlexContainer.Right, null, /*#__PURE__*/_react.default.createElement(_DmsExport.DmsExport, {
    table: table
  })));
  return /*#__PURE__*/_react.default.createElement(_DmsPage.DmsPage, {
    name: "Products"
  }, /*#__PURE__*/_react.default.createElement(_DmsAltBox.DmsAltBox.Card, null, /*#__PURE__*/_react.default.createElement(_DmsAltBox.DmsAltBox.Header, null, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "h3",
    sx: {
      fontSize: '1.1rem'
    }
  }, _reactIntlUniversal.default.get("Products").d("Products"))), /*#__PURE__*/_react.default.createElement(_DmsAltBox.DmsAltBox.Body, null, /*#__PURE__*/_react.default.createElement(_DmsTable.DmsTable, {
    header: header,
    managed: true,
    needs_authentication: true,
    ref: table,
    url: '/product/table',
    toolbar: toolbar
  }))));
};
exports.DmsPageProduct = DmsPageProduct;